import { AmbassadorPromotionLevelEnum } from "src/app/modules/ambassadors-promotion/models/enums/AmbassadorPromotionLevelEnum"
import { SubscriptionTypeEnum } from "./enum/SubscriptionTypeEnum"
import { UserTypeEnum } from "./enum/UserTypeEnum"

export class MembershipInfo {
  membershipNumber!: string
  fullName!: string
  membershipType!: UserTypeEnum
  subscriptionTypeEnum!: SubscriptionTypeEnum
  identityNumber!: string
  joinedDate!: string
  ambassadorLevel!:AmbassadorPromotionLevelEnum
}
